<template>
    <notification-item
        title="Pozvánka přijata"
        :created="data.created"
        :author="data.payload.teamName"
        avatar="/img/myteam/Team-Crest.png"
        :link="{ name: 'teamDetail', params: { id: data.payload.teamId } }"
    >
        <p>Pozvánku do vašeho týmu hráč <span class="semibold semibold--textgreen"><router-link :to="{ name: 'userDetail', params: { id: data.payload.userId } }">{{ data.payload.userName }}</router-link></span> přijal.</p>

        <template v-slot:actions>
            <v-btn
                color="primary" dark
                :to="{ name: 'myTeam' }"
            >
                Zobrazit tým
            </v-btn>
        </template>
    </notification-item>
</template>

<script>
    import NotificationMixin from '../NotificationMixin';

    export default {
        name: 'TeamInvitationAccepted',
        mixins: [NotificationMixin],
    }
</script>

